export default __webpack_public_path__ + "static/media/ajinifesin.ee3c18ac.png";